module.exports = __webpack_public_path__ + "img/salvus.ac48f0b4.png";